import { create } from 'zustand';
import { ROUTES } from '../shared/constants/routes';
import { createNavigationContainerRef } from '@react-navigation/native';
export const navRef = createNavigationContainerRef();
export interface RouteInfo {
  name: string;
  params?: any;
}

interface NavState {
  history: RouteInfo[];

  pushRoute: (
    route?: RouteInfo,
    pushIfSameNameWithDifferentParams?: boolean
  ) => void;

  popRoute: () => RouteInfo | null;

  getCurrentRoute: () => RouteInfo | null;
  getPreviousRoute: () => RouteInfo | null;

  setHistory: (history: RouteInfo[]) => void;
}

const areParamsEqual = (a?: any, b?: any) =>
  JSON.stringify(a ?? {}) === JSON.stringify(b ?? {});

export const useNavStore = create<NavState>((set, get) => ({
  history: [{ name: ROUTES.WELCOME_ONBOARDING }],

  setHistory: (history) => set({ history }),

  pushRoute: (route) => {
    if (!route) return;
    const { history } = get();
    const previous = history[history.length - 1];

    // different route → always push
    if (!previous || previous.name !== route.name) {
      set({ history: [...history, route] });
      return;
    }

    // same route name
    if (!areParamsEqual(previous.params, route.params)) {
      const updated = {
        ...previous,
        params: {
          ...(previous.params ?? {}),
          ...(route.params ?? {}), // update / add new params
        },
      };

      set({ history: [...history.slice(0, -1), updated] });
    }
  },

  popRoute: () => {
    const { history, getCurrentRoute } = get();

    if (history.length <= 1) return null;

    const newHistory = history.slice(0, -1);
    const previous = newHistory[newHistory.length - 1];
    //previous.params = { ...(getCurrentRoute()?.params ?? {}), ...(previous.params ?? {}) }
    set({ history: newHistory });
    return previous
      ? { ...previous, params: previous.params ? { ...previous.params } : undefined }
      : null;
  },

  getCurrentRoute: () => {
    const { history } = get();
    return history.length ? history[history.length - 1] : null;
  },

  getPreviousRoute: () => {
    const { history } = get();
    return history.length > 1 ? history[history.length - 2] : null;
  },
}));
